/* unplugin-vue-components disabled */import script from "./InvoiceDetailPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceDetailPopup.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceDetailPopup.vue?vue&type=style&index=0&id=d888c1a4&lang=scss"

const __exports__ = script;

export default __exports__